<!-- Toast overlay — sits above the shell -->
<app-notification />

<gz-app-shell [collapsible]="false" contentMaxWidth="none">
  <!-- ── Brand ─────────────────────────────────────────────────────── -->
  <div slot="brand" class="gz-brand">
    <img src="/images/partner_black.png" alt="Gozem Partner" class="gz-brand-logo" />
  </div>

  <!-- ── Navigation ────────────────────────────────────────────────── -->
  <ng-container slot="nav">
    @for (section of sections; track section.id) {
      <div class="gz-nav-section">
        <div class="gz-nav-section-label">{{ section.label }}</div>
        @for (item of section.items; track item.id ?? item.label) {
          <gz-nav-item
            [label]="item.label"
            [icon]="item.icon"
            [active]="isActive(item.route)"
            [badge]="item.badge ?? ''"
            (pressed)="navigate(item.route)"
          />
        }
      </div>
    }
  </ng-container>

  <!-- ── Topbar ─────────────────────────────────────────────────────── -->
  <div slot="topbar" class="gz-topbar">
    <!-- Account switcher (left of topbar) -->
    <app-account-switcher />

    <!-- Right-side actions -->
    <div class="gz-topbar-actions">
      <!-- ── Notifications ─────────────────────────────────────────── -->

      <!-- ── Profile ───────────────────────────────────────────────── -->
      <div class="gz-topbar-item">
        <button
          type="button"
          class="gz-profile-btn"
          [attr.aria-expanded]="showProfile()"
          [attr.aria-label]="'Menu utilisateur — ' + profileDisplayName()"
          (click)="toggleProfile()"
        >
          <div class="gz-profile-avatar" aria-hidden="true">
            <img
              ngSrc="/images/merchant-avatar.png"
              width="28"
              height="28"
              class="gz-profile-avatar-icon"
              alt=""
            />
          </div>
          <i
            class="ri-arrow-down-s-line gz-profile-chevron"
            [class.rotate-180]="showProfile()"
            aria-hidden="true"
          ></i>
        </button>

        @if (showProfile()) {
          <div
            class="gz-dropdown gz-dropdown--right"
            role="menu"
            tabindex="-1"
            style="min-width: 272px"
          >
            <!-- User info -->
            <div class="gz-dropdown-header gz-dropdown-header--centered">
              <div class="gz-profile-avatar gz-profile-avatar--lg" aria-hidden="true">
                <img
                  ngSrc="/images/merchant-avatar.png"
                  width="56"
                  height="56"
                  class="gz-profile-avatar-icon"
                  alt=""
                />
              </div>
              <p class="gz-profile-name">{{ profileDisplayName() }}</p>
              <p class="gz-profile-email">{{ merchantEmail() || currentUser()?.email }}</p>
            </div>

            <!-- Account settings -->
            <div class="gz-dropdown-section">
              <button type="button" class="gz-menu-row" (click)="goToSettings()">
                <div class="gz-menu-row-left">
                  <i class="ri-settings-3-line gz-menu-row-icon" aria-hidden="true"></i>
                  <span class="gz-menu-row-label">Paramètres du compte</span>
                </div>
                <i class="ri-arrow-right-s-line gz-menu-row-arrow" aria-hidden="true"></i>
              </button>
            </div>

            <!-- Logout -->
            <div class="gz-dropdown-section">
              <button type="button" class="gz-menu-row" (click)="onLogout()">
                <div class="gz-menu-row-left">
                  <i class="ri-logout-box-line gz-menu-row-icon" aria-hidden="true"></i>
                  <span class="gz-menu-row-label">Déconnexion</span>
                </div>
                <i class="ri-arrow-right-s-line gz-menu-row-arrow" aria-hidden="true"></i>
              </button>
            </div>

            <!-- Footer links -->
            <div class="gz-dropdown-footer gz-dropdown-footer--center">
              <p class="gz-dropdown-links">Confidentialité · Conditions d'utilisation</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- ── Page content ──────────────────────────────────────────────── -->
  <router-outlet />
</gz-app-shell>
